// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-senter {
  position: relative;
  width: 100%;
  height: 100%;
}
.help-senter__auth {
  color: #54a788;
  margin-top: 100px !important;
  text-align: center;
}
.help-senter__auth .loaderWrapper {
  margin-top: 50px;
}
.help-senter__loader {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/index.scss","webpack://./node_modules/@ergeon/core-components/src/components/variables.default.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AADF;AAGE;EACE,cCiBM;EDhBN,4BAAA;EACA,kBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;AAHJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
